import type {Context} from '../types';

// Fix legacy lightbox images
export default (context: Context) => {
  const {
    node: {jsonNode},
  } = context;
  const {data = {}} = jsonNode;
  const images = data.json && data.json.images;

  return {
    needed: data.lightbox && images,
    logData: {
      msg: 'Legacy image lightbox with data.json.images',
      meta: {
        nodeId: jsonNode._id,
      },
    },
    apply: () => {
      images.forEach(function (item: Record<string, any>) {
        item.type = 'image';
        item.originalUrl = item.url;
      });
      data.json.items = images;
      // eslint-disable-next-line webflow/no-delete
      delete data.json.images;
    },
  };
};
